// UK National Insurance number validator
// Format: 2 letters (excluding D, F, I, Q, U, V), 6 digits, 1 letter (A-D)
const NI_REGEX = /^[A-CEGHJ-PR-TW-Z]{2}\d{6}[A-D]$/i

export const isValidNI = (value) => {
  if (!value || typeof value !== 'string') {
    return false
  }

  return NI_REGEX.test(value)
}
